import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { authAPI } from '../lib/api';
import { setSession } from '../lib/auth';
import { t } from '../lib/i18n';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { data } = await authAPI.login(username.trim(), password);
      setSession(data.token, { name: data.name, role: data.role, mid: data.mid || '', pr: data.pr || null });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || t('Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <Brand size="lg" className="justify-center" />
          <div className="mt-2 text-sm text-pm-muted">{t('Project management')}</div>
        </div>
        <form
          onSubmit={submit}
          className="rounded-lg border border-pm-border bg-pm-surface p-6 space-y-4"
        >
          <div>
            <label htmlFor="pms-user" className="block text-sm text-pm-muted mb-1.5">
              {t('Username or email')}
            </label>
            <input
              id="pms-user"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              className="w-full rounded-md border border-pm-border bg-pm-input px-3 py-2 text-sm outline-none focus:border-[var(--pm-focus-border)]"
            />
          </div>
          <div>
            <label htmlFor="pms-pass" className="block text-sm text-pm-muted mb-1.5">
              {t('Password')}
            </label>
            <input
              id="pms-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full rounded-md border border-pm-border bg-pm-input px-3 py-2 text-sm outline-none focus:border-[var(--pm-focus-border)]"
            />
          </div>
          {error && (
            <p role="alert" className="text-sm" style={{ color: 'var(--pm-danger)' }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-md bg-pm-accent px-3 py-2 text-sm font-semibold text-pm-accent-ink disabled:opacity-60"
          >
            {busy ? t('Signing in…') : t('Sign in')}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-pm-faint">
          {t('Access is limited to attached members during development.')}
        </p>
      </div>
    </div>
  );
}
